module.exports = __webpack_public_path__ + "static/media/tv.3d842cc9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tv.svg
// module id = 2232
// module chunks = 0